import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

// import Filter from 'bad-words'
import { ref, onUnmounted, computed } from 'vue'

const config = {
  apiKey: "AIzaSyCdvoGZUaIprsiCRMbe_eYX7WBZAZf6ehE",
  authDomain: "archconfession-1d0cd.firebaseapp.com",
  projectId: "archconfession-1d0cd",
  storageBucket: "archconfession-1d0cd.appspot.com",
  messagingSenderId: "150633776611",
  appId: "1:150633776611:web:759732922dafcebbd20cd6",
  measurementId: "G-900YGJ4V5R"
}

firebase.initializeApp(config)

const auth = firebase.auth()

export function useAuth() {
  const user = ref(null)
  const unsubscribe = auth.onAuthStateChanged(_user => (user.value = _user))
  onUnmounted(unsubscribe)
  const isLogin = computed(() => user.value !== null)

  const signIn = async () => {
    const googleProvider = new firebase.auth.GoogleAuthProvider()
    await auth.signInWithPopup(googleProvider)
  }
  const signOut = () => auth.signOut()

  return { user, isLogin, signIn, signOut }
}

const firestore = firebase.firestore()
const messagesCollection = firestore.collection('messages')
const messagesQuery = messagesCollection.orderBy('createdAt', 'desc').limit(100)
// const filter = new Filter()

export function useChat() {
  const messages = ref([])
  const unsubscribe = messagesQuery.onSnapshot(snapshot => {
    messages.value = snapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      // .reverse()
  })
  onUnmounted(unsubscribe)

  const messagesNumbers = computed(() => messages.value.length)

  const { user } = useAuth()

  const sendMessage = async text => {
    const { photoURL, uid, displayName } = user.value
    await messagesCollection.add({
      userName: displayName,
      userId: uid,
      userPhotoURL: photoURL,
      text: text,
      likes: 0,
      createdAt: firebase.firestore.FieldValue.serverTimestamp()
    })
  }

  const removeMessage = async id => {
    await messagesCollection.doc(id).delete()
  }

  const addLike = async (id, likes) => {
    await messagesCollection.doc(id).update({
      likes
    })
  }

  return { messages, messagesNumbers, sendMessage, removeMessage, addLike }
}